import { render, staticRenderFns } from "./table-header-action.vue?vue&type=template&id=0b86c23e&scoped=true&"
import script from "./table-header-action.vue?vue&type=script&lang=js&"
export * from "./table-header-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b86c23e",
  null
  
)

export default component.exports